export const NAVIGATION = "cp_navigation";
export const FILES = "cp_files";
export const AXIOS_ERROR_MESSAGE = "cp_axios_error_message";
export const COPY_TO_CLIPBOARD = "cp_copy_to_clipboard";
export const MUI_GRID = "cp_mui_grid";
export const CONFIRMATION = "cp_confirmation";
export const GRID_STATE = "cp_grid_state";
export const EDITABLE_MUI_GRID = "cp_editable_mui_grid";
export const ALERTS = "cp_alerts";
export const CONTENT_NOT_FOUND = "cp_content_not_found";
export const MENU = "cp_menu";
export const FOOTER = "cp_footer";
export const CART_NOTIFICATION = "cp_cart_notification";
export const DASHBOARD = "cp_dashboard";
export const PRODUCT_INFO = "cp_product_info";
